// extracted by mini-css-extract-plugin
export default {"sunIcon":"SummerPaywall_sunIcon__DKTyG"};